import { createContext } from "react";

export const SelectContext = createContext<{
	size: "md" | "sm";
	variant: "default" | "plain";
}>({
	size: "sm",
	variant: "default",
});
